import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

import type { ParamParseKey } from "react-router";

export const useGetRoomListPageParams = (): { hotelID: string } => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.PLAN.TOP>>();

	if (!hotelID) {
		notifyUserEventInfo({
			variant: "error",
			description: "アクセスできないURLです。トップページから再度操作してください。",
		});
		redirect("/");
	}

	return { hotelID: hotelID! };
};
